import type { CVListItemDto } from '@cibli/shared';

import { createContext, ReactNode, useContext } from 'react';

interface CVListContextValue {
  onEdit: (cvId: string) => void;
  onDownload: (cv: CVListItemDto) => void;
  onDelete: (cvId: string) => void;
  deletingId: string | null;
  downloadingId: string | null;
  isDownloading: boolean;
}

const CVListContext = createContext<CVListContextValue | null>(null);

interface CVListProviderProps {
  children: ReactNode;
  value: CVListContextValue;
}

export function CVListProvider({ children, value }: CVListProviderProps) {
  return <CVListContext.Provider value={value}>{children}</CVListContext.Provider>;
}

// eslint-disable-next-line react-refresh/only-export-components
export function useCVListContext() {
  const context = useContext(CVListContext);
  if (!context) {
    throw new Error('useCVListContext must be used within CVListProvider');
  }
  return context;
}
